// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   VoicesPage Styles
   ====================== */

.voices-page-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  padding: 32px 36px 0;
  overflow: hidden;
  box-sizing: border-box;
  background: var(--color-bg-root);
}

.voices-page-header-section {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.voices-page-header-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.voices-page-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--color-text-primary);
  margin: 0;
  letter-spacing: -0.3px;
}

.voices-page-subtitle {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0;
}

.voices-page-new-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 4px;
  border: 1px solid var(--color-text-primary);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: opacity 0.15s ease;
  white-space: nowrap;
  flex-shrink: 0;
}

.voices-page-new-button:hover {
  opacity: 0.88;
}

.voices-page-search-row {
  flex-shrink: 0;
  margin-bottom: 16px;
}

.voices-page-search {
  width: 100%;
  max-width: 340px;
  padding: 8px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color 0.15s ease;
}

.voices-page-search:focus {
  outline: none;
  border-color: var(--color-text-secondary);
}

.voices-page-search::placeholder {
  color: var(--color-text-secondary);
}

.voices-page-scroll {
  flex: 1 1;
  overflow-y: auto;
  padding-bottom: 32px;
}

.voices-page-loading {
  color: var(--color-text-secondary);
  font-size: 13px;
  padding: 40px 0;
  text-align: center;
}

.voices-error {
  padding: 10px 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: rgba(220, 38, 38, 0.08);
  color: #dc2626;
  font-size: 13px;
  margin-bottom: 12px;
}

/* Empty state */
.voices-page-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 80px 24px;
  text-align: center;
  color: var(--color-text-secondary);
}

.voices-page-empty-icon {
  opacity: 0.3;
  margin-bottom: 4px;
}

.voices-page-empty p {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}

.voices-page-empty-hint {
  font-size: 13px !important;
  font-weight: 400 !important;
  opacity: 0.7;
}

.voices-page-empty-cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 9px 16px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.voices-page-empty-cta:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

/* Grid */
.voices-page-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 14px;
}

/* ======================
   Voice card
   ====================== */
.voice-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background: var(--color-bg-sidebar);
  cursor: pointer;
  transition: border-color 0.15s ease;
}

.voice-card:hover {
  border-color: var(--color-text-secondary);
}

.voice-card:focus {
  outline: 2px solid var(--color-focus-ring);
  outline-offset: 1px;
}

.voice-card-top {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.voice-card-orb {
  position: relative;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: inset 0 -6px 12px rgba(0, 0, 0, 0.18);
}

.voice-card-play {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.28);
  color: #fff;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, background 0.15s ease;
}

.voice-card:hover .voice-card-play,
.voice-card-play.playing {
  opacity: 1;
}

.voice-card-play:hover {
  background: rgba(0, 0, 0, 0.45);
}

.voice-card-heading {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
  flex: 1 1;
}

.voice-card-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.voice-card-badges {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.voice-card-provider {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 999px;
  border: 1px solid var(--color-border-input);
  color: var(--color-text-secondary);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  white-space: nowrap;
}

.voice-card-character {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 7px;
  border-radius: 999px;
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.voice-card-delete {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.voice-card:hover .voice-card-delete {
  opacity: 0.7;
}

.voice-card-delete:hover {
  opacity: 1 !important;
  color: #dc2626;
  background: rgba(220, 38, 38, 0.08);
}

.voice-card-description {
  margin: 0;
  font-size: 12px;
  color: var(--color-text-secondary);
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.voice-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
}

.voice-card-cta {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-secondary);
  opacity: 0.75;
  transition: color 0.15s ease, opacity 0.15s ease;
}

.voice-card:hover .voice-card-cta {
  color: var(--color-accent-base);
  opacity: 1;
}

/* Animated equalizer */
.voices-equalizer {
  display: inline-flex;
  align-items: flex-end;
  gap: 2px;
  height: 14px;
  flex-shrink: 0;
}

.voices-equalizer span {
  width: 3px;
  border-radius: 1px;
  background: var(--color-accent-base);
  animation: voicesEqBounce 0.9s ease-in-out infinite;
}

.voices-equalizer span:nth-child(1) { height: 60%; animation-delay: 0s; }
.voices-equalizer span:nth-child(2) { height: 100%; animation-delay: 0.15s; }
.voices-equalizer span:nth-child(3) { height: 45%; animation-delay: 0.3s; }
.voices-equalizer span:nth-child(4) { height: 80%; animation-delay: 0.45s; }

@keyframes voicesEqBounce {
  0%, 100% { transform: scaleY(0.4); }
  50% { transform: scaleY(1); }
}

/* ======================
   Modals (shared shell)
   ====================== */
.voices-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 24px;
  animation: voicesOverlayIn 0.18s ease;
}

@keyframes voicesOverlayIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.voices-studio-close {
  position: absolute;
  top: 14px;
  right: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  z-index: 2;
}

.voices-studio-close:hover {
  background: var(--color-bg-input);
  color: var(--color-text-primary);
}

/* ======================
   TTS Studio
   ====================== */
.voices-studio {
  position: relative;
  display: flex;
  width: 100%;
  max-width: 780px;
  max-height: min(640px, calc(100vh - 48px));
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  background: var(--color-bg-sidebar);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.28);
  overflow: hidden;
  animation: voicesModalIn 0.16s ease-out;
}

@keyframes voicesModalIn {
  from { opacity: 0; transform: translateY(8px) scale(0.985); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.voices-studio-identity {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  width: 240px;
  flex-shrink: 0;
  padding: 32px 22px;
  border-right: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  overflow-y: auto;
}

.voices-studio-orb {
  position: relative;
  width: 92px;
  height: 92px;
  border-radius: 50%;
  box-shadow: inset 0 -12px 22px rgba(0, 0, 0, 0.2), 0 6px 18px rgba(0, 0, 0, 0.14);
  flex-shrink: 0;
}

.voices-studio-orb-play {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.22);
  color: #fff;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, background 0.15s ease;
}

.voices-studio-orb:hover .voices-studio-orb-play,
.voices-studio-orb-play.playing {
  opacity: 1;
}

.voices-studio-orb-play:hover {
  background: rgba(0, 0, 0, 0.4);
}

.voices-studio-name {
  margin: 4px 0 0;
  font-size: 17px;
  font-weight: 700;
  color: var(--color-text-primary);
  letter-spacing: -0.2px;
  word-break: break-word;
}

.voices-studio-badges {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
}

.voices-studio-description-wrap {
  width: 100%;
}

.voices-studio-description {
  margin: 2px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: var(--color-text-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.voices-studio-description.is-expanded {
  display: block;
  overflow: visible;
}

.voices-studio-description-toggle {
  margin-top: 5px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--color-accent-base);
  font: inherit;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}

.voices-studio-description-toggle:hover {
  text-decoration: underline;
}

.voices-studio-description-toggle:focus-visible {
  outline: 2px solid var(--color-accent-base);
  outline-offset: 3px;
  border-radius: 2px;
}

.voices-studio-preview-hint {
  margin-top: auto;
  font-size: 11px;
  color: var(--color-text-secondary);
  opacity: 0.65;
}

.voices-studio-main {
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 1 1;
  min-width: 0;
  padding: 28px 26px 24px;
  overflow-y: auto;
}

.voices-studio-header {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.voices-studio-title {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--color-text-primary);
}

.voices-studio-subtitle {
  margin: 0;
  font-size: 12px;
  color: var(--color-text-secondary);
}

.voices-studio-input-wrap {
  position: relative;
}

.voices-studio-textarea {
  width: 100%;
  padding: 12px 14px 26px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  line-height: 1.55;
  font-family: inherit;
  box-sizing: border-box;
  resize: vertical;
  min-height: 110px;
  transition: border-color 0.15s ease;
}

.voices-studio-textarea:focus {
  outline: none;
  border-color: var(--color-text-secondary);
}

.voices-studio-textarea::placeholder {
  color: var(--color-text-secondary);
}

.voices-studio-charcount {
  position: absolute;
  bottom: 10px;
  right: 12px;
  font-size: 10px;
  color: var(--color-text-secondary);
  opacity: 0.6;
  pointer-events: none;
}

.voices-studio-controls {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
}

.voices-studio-slider {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 130px;
  flex: 1 1;
}

.voices-studio-slider-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.voices-studio-slider-label strong {
  color: var(--color-text-primary);
  font-weight: 700;
}

.voices-studio-slider input[type='range'] {
  width: 100%;
  accent-color: var(--color-accent-base);
  cursor: pointer;
}

.voices-generate-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 9px 18px;
  border-radius: 5px;
  border: 1px solid var(--color-text-primary);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: opacity 0.15s ease;
  white-space: nowrap;
}

.voices-generate-button:hover:not(:disabled) {
  opacity: 0.88;
}

.voices-generate-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.voices-generate-button--wide {
  width: 100%;
}

.voices-spin {
  animation: voicesSpin 0.9s linear infinite;
}

@keyframes voicesSpin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Result cards */
.voices-studio-result,
.voices-create-result {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background: var(--color-bg-canvas-surface);
}

.voices-studio-result-label {
  font-size: 10px;
  font-weight: 700;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  opacity: 0.7;
}

.voices-studio-result-text {
  margin: 0;
  font-size: 12px;
  color: var(--color-text-secondary);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.voices-studio-history {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.voices-studio-history-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
}

.voices-studio-history-text {
  margin: 0;
  font-size: 11px;
  color: var(--color-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ======================
   Audio player
   ====================== */
.voices-player {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.voices-player-play {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid var(--color-text-primary);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.15s ease;
}

.voices-player-play:hover {
  opacity: 0.85;
}

.voices-player--compact .voices-player-play {
  width: 26px;
  height: 26px;
}

.voices-player-track {
  position: relative;
  flex: 1 1;
  height: 5px;
  border-radius: 999px;
  background: var(--color-bg-input);
  cursor: pointer;
  min-width: 60px;
  overflow: hidden;
}

.voices-player-progress {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  border-radius: 999px;
  background: var(--color-accent-base);
  transition: width 0.1s linear;
}

.voices-player-time {
  font-size: 10px;
  font-variant-numeric: tabular-nums;
  color: var(--color-text-secondary);
  flex-shrink: 0;
  white-space: nowrap;
}

.voices-player-download {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 4px;
  color: var(--color-text-secondary);
  flex-shrink: 0;
  transition: background 0.15s ease, color 0.15s ease;
}

.voices-player-download:hover {
  background: var(--color-bg-input);
  color: var(--color-text-primary);
}

/* ======================
   Create Voice Studio
   ====================== */
.voices-create-studio {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 48px);
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  background: var(--color-bg-sidebar);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.28);
  overflow: hidden;
  animation: voicesModalIn 0.16s ease-out;
}

.voices-create-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 22px 24px 16px;
  border-bottom: 1px solid var(--color-border-input);
  flex-shrink: 0;
}

.voices-create-header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, var(--color-accent-base), rgba(0, 0, 0, 0.25));
  color: #fff;
  flex-shrink: 0;
}

.voices-create-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--color-text-primary);
  letter-spacing: -0.2px;
}

.voices-create-subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  color: var(--color-text-secondary);
}

.voices-create-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 24px 24px;
  overflow-y: auto;
}

.voices-create-label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.voices-create-textarea {
  padding: 10px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  line-height: 1.5;
  font-family: inherit;
  box-sizing: border-box;
  resize: vertical;
  transition: border-color 0.15s ease;
}

.voices-create-textarea:focus {
  outline: none;
  border-color: var(--color-text-secondary);
}

.voices-create-textarea::placeholder {
  color: var(--color-text-secondary);
}

/* Reference selector */
.voices-create-refs {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.voices-create-refs-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

.voices-create-refs-tabs {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.voices-refs-tab {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.18s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
  -webkit-user-select: none;
}

.voices-refs-tab:hover {
  border-color: var(--color-text-secondary);
  color: var(--color-text-primary);
}

.voices-refs-tab.active {
  background: var(--color-text-primary);
  border-color: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
}

.voices-refs-panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border: 1px dashed var(--color-border-input);
  border-radius: 8px;
}

.voices-refs-hint {
  margin: 0;
  font-size: 11px;
  color: var(--color-text-secondary);
  opacity: 0.8;
}

.voices-refs-audio-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.voices-refs-audio-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 12px;
  min-width: 0;
}

.voices-refs-audio-name {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.voices-refs-audio-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  flex-shrink: 0;
  transition: color 0.15s ease, background 0.15s ease;
}

.voices-refs-audio-remove:hover {
  color: #dc2626;
  background: rgba(220, 38, 38, 0.08);
}

.voices-refs-add {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
  align-self: flex-start;
}

.voices-refs-add:hover {
  background: var(--color-bg-input);
  border-color: var(--color-text-secondary);
  color: var(--color-text-primary);
}

.voices-refs-image-preview {
  position: relative;
  width: 120px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
}

.voices-refs-image-preview img {
  display: block;
  width: 100%;
  height: auto;
}

.voices-refs-image-remove {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  cursor: pointer;
  transition: background 0.15s ease;
}

.voices-refs-image-remove:hover {
  background: rgba(0, 0, 0, 0.75);
}

/* Save row */
.voices-create-save-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.voices-create-name-input {
  flex: 1 1;
  padding: 9px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 5px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 13px;
  font-family: inherit;
  box-sizing: border-box;
  min-width: 0;
  transition: border-color 0.15s ease;
}

.voices-create-name-input:focus {
  outline: none;
  border-color: var(--color-text-secondary);
}

.voices-create-name-input::placeholder {
  color: var(--color-text-secondary);
}

.voices-save-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 16px;
  border-radius: 5px;
  border: 1px solid var(--color-accent-base);
  background: var(--color-accent-base);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: opacity 0.15s ease;
  white-space: nowrap;
  flex-shrink: 0;
}

.voices-save-button:hover:not(:disabled) {
  opacity: 0.88;
}

.voices-save-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Responsive: stack the TTS studio on small screens */
@media (max-width: 720px) {
  .voices-studio {
    flex-direction: column;
    max-height: calc(100vh - 32px);
  }

  .voices-studio-identity {
    width: auto;
    flex-direction: row;
    text-align: left;
    align-items: center;
    padding: 18px 20px;
    border-right: none;
    border-bottom: 1px solid var(--color-border-input);
    gap: 14px;
  }

  .voices-studio-orb {
    width: 56px;
    height: 56px;
  }

  .voices-studio-description,
  .voices-studio-preview-hint {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/VoicesPage.css"],"names":[],"mappings":"AAAA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;;2BAE2B;AAC3B;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,UAAU;EACV,qDAAqD;AACvD;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,2CAA2C;EAC3C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,UAAU;EACV,uEAAuE;AACzE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;EAC/B,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA,sCAAsC,WAAW,EAAE,mBAAmB,EAAE;AACxE,sCAAsC,YAAY,EAAE,sBAAsB,EAAE;AAC5E,sCAAsC,WAAW,EAAE,qBAAqB,EAAE;AAC1E,sCAAsC,WAAW,EAAE,sBAAsB,EAAE;;AAE3E;EACE,WAAW,sBAAsB,EAAE;EACnC,MAAM,oBAAoB,EAAE;AAC9B;;AAEA;;2BAE2B;AAC3B;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;;2BAE2B;AAC3B;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;EAC3C,mBAAmB;EACnB,mCAAmC;EACnC,2CAA2C;EAC3C,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iDAAiD;EACjD,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iFAAiF;EACjF,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,UAAU;EACV,qDAAqD;AACvD;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,iBAAiB;AACjB;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,WAAW;EACX,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,oBAAoB;EACpB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;;2BAE2B;AAC3B;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,mCAAmC;EACnC,2CAA2C;EAC3C,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6FAA6F;EAC7F,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kDAAkD;EAClD,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4EAA4E;EAC5E,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kDAAkD;IAClD,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":["/* ======================\n   VoicesPage Styles\n   ====================== */\n\n.voices-page-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  padding: 32px 36px 0;\n  overflow: hidden;\n  box-sizing: border-box;\n  background: var(--color-bg-root);\n}\n\n.voices-page-header-section {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.voices-page-header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.voices-page-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  margin: 0;\n  letter-spacing: -0.3px;\n}\n\n.voices-page-subtitle {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n.voices-page-new-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 4px;\n  border: 1px solid var(--color-text-primary);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.voices-page-new-button:hover {\n  opacity: 0.88;\n}\n\n.voices-page-search-row {\n  flex-shrink: 0;\n  margin-bottom: 16px;\n}\n\n.voices-page-search {\n  width: 100%;\n  max-width: 340px;\n  padding: 8px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease;\n}\n\n.voices-page-search:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n}\n\n.voices-page-search::placeholder {\n  color: var(--color-text-secondary);\n}\n\n.voices-page-scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding-bottom: 32px;\n}\n\n.voices-page-loading {\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  padding: 40px 0;\n  text-align: center;\n}\n\n.voices-error {\n  padding: 10px 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: rgba(220, 38, 38, 0.08);\n  color: #dc2626;\n  font-size: 13px;\n  margin-bottom: 12px;\n}\n\n/* Empty state */\n.voices-page-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 80px 24px;\n  text-align: center;\n  color: var(--color-text-secondary);\n}\n\n.voices-page-empty-icon {\n  opacity: 0.3;\n  margin-bottom: 4px;\n}\n\n.voices-page-empty p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.voices-page-empty-hint {\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  opacity: 0.7;\n}\n\n.voices-page-empty-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 8px;\n  padding: 9px 16px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.voices-page-empty-cta:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n/* Grid */\n.voices-page-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 14px;\n}\n\n/* ======================\n   Voice card\n   ====================== */\n.voice-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 16px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background: var(--color-bg-sidebar);\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n}\n\n.voice-card:hover {\n  border-color: var(--color-text-secondary);\n}\n\n.voice-card:focus {\n  outline: 2px solid var(--color-focus-ring);\n  outline-offset: 1px;\n}\n\n.voice-card-top {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.voice-card-orb {\n  position: relative;\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  box-shadow: inset 0 -6px 12px rgba(0, 0, 0, 0.18);\n}\n\n.voice-card-play {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.28);\n  color: #fff;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.15s ease, background 0.15s ease;\n}\n\n.voice-card:hover .voice-card-play,\n.voice-card-play.playing {\n  opacity: 1;\n}\n\n.voice-card-play:hover {\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.voice-card-heading {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n  flex: 1;\n}\n\n.voice-card-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.voice-card-badges {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.voice-card-provider {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 7px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.voice-card-character {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 7px;\n  border-radius: 999px;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  font-weight: 600;\n  white-space: nowrap;\n  max-width: 140px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.voice-card-delete {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.15s ease, color 0.15s ease, background 0.15s ease;\n}\n\n.voice-card:hover .voice-card-delete {\n  opacity: 0.7;\n}\n\n.voice-card-delete:hover {\n  opacity: 1 !important;\n  color: #dc2626;\n  background: rgba(220, 38, 38, 0.08);\n}\n\n.voice-card-description {\n  margin: 0;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  line-height: 1.45;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.voice-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: auto;\n}\n\n.voice-card-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  opacity: 0.75;\n  transition: color 0.15s ease, opacity 0.15s ease;\n}\n\n.voice-card:hover .voice-card-cta {\n  color: var(--color-accent-base);\n  opacity: 1;\n}\n\n/* Animated equalizer */\n.voices-equalizer {\n  display: inline-flex;\n  align-items: flex-end;\n  gap: 2px;\n  height: 14px;\n  flex-shrink: 0;\n}\n\n.voices-equalizer span {\n  width: 3px;\n  border-radius: 1px;\n  background: var(--color-accent-base);\n  animation: voicesEqBounce 0.9s ease-in-out infinite;\n}\n\n.voices-equalizer span:nth-child(1) { height: 60%; animation-delay: 0s; }\n.voices-equalizer span:nth-child(2) { height: 100%; animation-delay: 0.15s; }\n.voices-equalizer span:nth-child(3) { height: 45%; animation-delay: 0.3s; }\n.voices-equalizer span:nth-child(4) { height: 80%; animation-delay: 0.45s; }\n\n@keyframes voicesEqBounce {\n  0%, 100% { transform: scaleY(0.4); }\n  50% { transform: scaleY(1); }\n}\n\n/* ======================\n   Modals (shared shell)\n   ====================== */\n.voices-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 24px;\n  animation: voicesOverlayIn 0.18s ease;\n}\n\n@keyframes voicesOverlayIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.voices-studio-close {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  z-index: 2;\n}\n\n.voices-studio-close:hover {\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n}\n\n/* ======================\n   TTS Studio\n   ====================== */\n.voices-studio {\n  position: relative;\n  display: flex;\n  width: 100%;\n  max-width: 780px;\n  max-height: min(640px, calc(100vh - 48px));\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  background: var(--color-bg-sidebar);\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.28);\n  overflow: hidden;\n  animation: voicesModalIn 0.16s ease-out;\n}\n\n@keyframes voicesModalIn {\n  from { opacity: 0; transform: translateY(8px) scale(0.985); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.voices-studio-identity {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 10px;\n  width: 240px;\n  flex-shrink: 0;\n  padding: 32px 22px;\n  border-right: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  overflow-y: auto;\n}\n\n.voices-studio-orb {\n  position: relative;\n  width: 92px;\n  height: 92px;\n  border-radius: 50%;\n  box-shadow: inset 0 -12px 22px rgba(0, 0, 0, 0.2), 0 6px 18px rgba(0, 0, 0, 0.14);\n  flex-shrink: 0;\n}\n\n.voices-studio-orb-play {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.22);\n  color: #fff;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.15s ease, background 0.15s ease;\n}\n\n.voices-studio-orb:hover .voices-studio-orb-play,\n.voices-studio-orb-play.playing {\n  opacity: 1;\n}\n\n.voices-studio-orb-play:hover {\n  background: rgba(0, 0, 0, 0.4);\n}\n\n.voices-studio-name {\n  margin: 4px 0 0;\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  letter-spacing: -0.2px;\n  word-break: break-word;\n}\n\n.voices-studio-badges {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.voices-studio-description-wrap {\n  width: 100%;\n}\n\n.voices-studio-description {\n  margin: 2px 0 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n  display: -webkit-box;\n  -webkit-line-clamp: 6;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.voices-studio-description.is-expanded {\n  display: block;\n  overflow: visible;\n}\n\n.voices-studio-description-toggle {\n  margin-top: 5px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--color-accent-base);\n  font: inherit;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.voices-studio-description-toggle:hover {\n  text-decoration: underline;\n}\n\n.voices-studio-description-toggle:focus-visible {\n  outline: 2px solid var(--color-accent-base);\n  outline-offset: 3px;\n  border-radius: 2px;\n}\n\n.voices-studio-preview-hint {\n  margin-top: auto;\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  opacity: 0.65;\n}\n\n.voices-studio-main {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  flex: 1;\n  min-width: 0;\n  padding: 28px 26px 24px;\n  overflow-y: auto;\n}\n\n.voices-studio-header {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.voices-studio-title {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n}\n\n.voices-studio-subtitle {\n  margin: 0;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.voices-studio-input-wrap {\n  position: relative;\n}\n\n.voices-studio-textarea {\n  width: 100%;\n  padding: 12px 14px 26px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  line-height: 1.55;\n  font-family: inherit;\n  box-sizing: border-box;\n  resize: vertical;\n  min-height: 110px;\n  transition: border-color 0.15s ease;\n}\n\n.voices-studio-textarea:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n}\n\n.voices-studio-textarea::placeholder {\n  color: var(--color-text-secondary);\n}\n\n.voices-studio-charcount {\n  position: absolute;\n  bottom: 10px;\n  right: 12px;\n  font-size: 10px;\n  color: var(--color-text-secondary);\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.voices-studio-controls {\n  display: flex;\n  align-items: flex-end;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.voices-studio-slider {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 130px;\n  flex: 1;\n}\n\n.voices-studio-slider-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n.voices-studio-slider-label strong {\n  color: var(--color-text-primary);\n  font-weight: 700;\n}\n\n.voices-studio-slider input[type='range'] {\n  width: 100%;\n  accent-color: var(--color-accent-base);\n  cursor: pointer;\n}\n\n.voices-generate-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 9px 18px;\n  border-radius: 5px;\n  border: 1px solid var(--color-text-primary);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n  white-space: nowrap;\n}\n\n.voices-generate-button:hover:not(:disabled) {\n  opacity: 0.88;\n}\n\n.voices-generate-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.voices-generate-button--wide {\n  width: 100%;\n}\n\n.voices-spin {\n  animation: voicesSpin 0.9s linear infinite;\n}\n\n@keyframes voicesSpin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Result cards */\n.voices-studio-result,\n.voices-create-result {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background: var(--color-bg-canvas-surface);\n}\n\n.voices-studio-result-label {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  opacity: 0.7;\n}\n\n.voices-studio-result-text {\n  margin: 0;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.voices-studio-history {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.voices-studio-history-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 10px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n}\n\n.voices-studio-history-text {\n  margin: 0;\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ======================\n   Audio player\n   ====================== */\n.voices-player {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.voices-player-play {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid var(--color-text-primary);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: opacity 0.15s ease;\n}\n\n.voices-player-play:hover {\n  opacity: 0.85;\n}\n\n.voices-player--compact .voices-player-play {\n  width: 26px;\n  height: 26px;\n}\n\n.voices-player-track {\n  position: relative;\n  flex: 1;\n  height: 5px;\n  border-radius: 999px;\n  background: var(--color-bg-input);\n  cursor: pointer;\n  min-width: 60px;\n  overflow: hidden;\n}\n\n.voices-player-progress {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  border-radius: 999px;\n  background: var(--color-accent-base);\n  transition: width 0.1s linear;\n}\n\n.voices-player-time {\n  font-size: 10px;\n  font-variant-numeric: tabular-nums;\n  color: var(--color-text-secondary);\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.voices-player-download {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 4px;\n  color: var(--color-text-secondary);\n  flex-shrink: 0;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.voices-player-download:hover {\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n}\n\n/* ======================\n   Create Voice Studio\n   ====================== */\n.voices-create-studio {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 560px;\n  max-height: calc(100vh - 48px);\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  background: var(--color-bg-sidebar);\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.28);\n  overflow: hidden;\n  animation: voicesModalIn 0.16s ease-out;\n}\n\n.voices-create-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 22px 24px 16px;\n  border-bottom: 1px solid var(--color-border-input);\n  flex-shrink: 0;\n}\n\n.voices-create-header-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: radial-gradient(circle at 30% 30%, var(--color-accent-base), rgba(0, 0, 0, 0.25));\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.voices-create-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--color-text-primary);\n  letter-spacing: -0.2px;\n}\n\n.voices-create-subtitle {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.voices-create-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px 24px 24px;\n  overflow-y: auto;\n}\n\n.voices-create-label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n.voices-create-textarea {\n  padding: 10px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  line-height: 1.5;\n  font-family: inherit;\n  box-sizing: border-box;\n  resize: vertical;\n  transition: border-color 0.15s ease;\n}\n\n.voices-create-textarea:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n}\n\n.voices-create-textarea::placeholder {\n  color: var(--color-text-secondary);\n}\n\n/* Reference selector */\n.voices-create-refs {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.voices-create-refs-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n.voices-create-refs-tabs {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.voices-refs-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: all 0.18s cubic-bezier(0.4, 0, 0.2, 1);\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.voices-refs-tab:hover {\n  border-color: var(--color-text-secondary);\n  color: var(--color-text-primary);\n}\n\n.voices-refs-tab.active {\n  background: var(--color-text-primary);\n  border-color: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n}\n\n.voices-refs-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 12px;\n  border: 1px dashed var(--color-border-input);\n  border-radius: 8px;\n}\n\n.voices-refs-hint {\n  margin: 0;\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  opacity: 0.8;\n}\n\n.voices-refs-audio-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.voices-refs-audio-chip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 12px;\n  min-width: 0;\n}\n\n.voices-refs-audio-name {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.voices-refs-audio-remove {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: color 0.15s ease, background 0.15s ease;\n}\n\n.voices-refs-audio-remove:hover {\n  color: #dc2626;\n  background: rgba(220, 38, 38, 0.08);\n}\n\n.voices-refs-add {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n  align-self: flex-start;\n}\n\n.voices-refs-add:hover {\n  background: var(--color-bg-input);\n  border-color: var(--color-text-secondary);\n  color: var(--color-text-primary);\n}\n\n.voices-refs-image-preview {\n  position: relative;\n  width: 120px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n}\n\n.voices-refs-image-preview img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.voices-refs-image-remove {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border: none;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.55);\n  color: #fff;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.voices-refs-image-remove:hover {\n  background: rgba(0, 0, 0, 0.75);\n}\n\n/* Save row */\n.voices-create-save-row {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.voices-create-name-input {\n  flex: 1;\n  padding: 9px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 5px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  font-family: inherit;\n  box-sizing: border-box;\n  min-width: 0;\n  transition: border-color 0.15s ease;\n}\n\n.voices-create-name-input:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n}\n\n.voices-create-name-input::placeholder {\n  color: var(--color-text-secondary);\n}\n\n.voices-save-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 16px;\n  border-radius: 5px;\n  border: 1px solid var(--color-accent-base);\n  background: var(--color-accent-base);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.voices-save-button:hover:not(:disabled) {\n  opacity: 0.88;\n}\n\n.voices-save-button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Responsive: stack the TTS studio on small screens */\n@media (max-width: 720px) {\n  .voices-studio {\n    flex-direction: column;\n    max-height: calc(100vh - 32px);\n  }\n\n  .voices-studio-identity {\n    width: auto;\n    flex-direction: row;\n    text-align: left;\n    align-items: center;\n    padding: 18px 20px;\n    border-right: none;\n    border-bottom: 1px solid var(--color-border-input);\n    gap: 14px;\n  }\n\n  .voices-studio-orb {\n    width: 56px;\n    height: 56px;\n  }\n\n  .voices-studio-description,\n  .voices-studio-preview-hint {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
